"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  Auth: () => Auth
});
module.exports = __toCommonJS(index_native_exports);
var import_react_native_nitro_modules = require("react-native-nitro-modules");
var import_nativeError = require("../nativeError");
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = import_react_native_nitro_modules.NitroModules.createHybridObject("OneAppleAuth");
  return hybrid;
}
async function signIn() {
  var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var _raw_state, _raw_identityToken, _raw_authorizationCode, _raw_email, _raw_fullName_namePrefix, _raw_fullName_givenName, _raw_fullName_middleName, _raw_fullName_familyName, _raw_fullName_nameSuffix, _raw_fullName_nickname;
  var result = await native().signIn({
    requestedScopes: options.requestedScopes,
    nonce: options.nonce,
    state: options.state
  }).catch(import_nativeError.rethrowNativeError);
  if (result.type === "cancel") return {
    type: "cancel"
  };
  var raw = result.credential;
  if (!raw) throw new Error("Auth.Apple.signIn: success without a credential");
  return {
    type: "success",
    credential: {
      user: raw.user,
      state: (_raw_state = raw.state) !== null && _raw_state !== void 0 ? _raw_state : null,
      identityToken: (_raw_identityToken = raw.identityToken) !== null && _raw_identityToken !== void 0 ? _raw_identityToken : null,
      authorizationCode: (_raw_authorizationCode = raw.authorizationCode) !== null && _raw_authorizationCode !== void 0 ? _raw_authorizationCode : null,
      email: (_raw_email = raw.email) !== null && _raw_email !== void 0 ? _raw_email : null,
      fullName: raw.fullName ? {
        namePrefix: (_raw_fullName_namePrefix = raw.fullName.namePrefix) !== null && _raw_fullName_namePrefix !== void 0 ? _raw_fullName_namePrefix : null,
        givenName: (_raw_fullName_givenName = raw.fullName.givenName) !== null && _raw_fullName_givenName !== void 0 ? _raw_fullName_givenName : null,
        middleName: (_raw_fullName_middleName = raw.fullName.middleName) !== null && _raw_fullName_middleName !== void 0 ? _raw_fullName_middleName : null,
        familyName: (_raw_fullName_familyName = raw.fullName.familyName) !== null && _raw_fullName_familyName !== void 0 ? _raw_fullName_familyName : null,
        nameSuffix: (_raw_fullName_nameSuffix = raw.fullName.nameSuffix) !== null && _raw_fullName_nameSuffix !== void 0 ? _raw_fullName_nameSuffix : null,
        nickname: (_raw_fullName_nickname = raw.fullName.nickname) !== null && _raw_fullName_nickname !== void 0 ? _raw_fullName_nickname : null
      } : null,
      realUserStatus: raw.realUserStatus
    }
  };
}
var Apple = Object.freeze({
  get isAvailable() {
    return native().isAvailable();
  },
  signIn,
  getCredentialState: function getCredentialState(user) {
    return native().getCredentialState(user).catch(import_nativeError.rethrowNativeError);
  }
});
var Auth = Object.freeze({
  Apple
});
//# sourceMappingURL=index.native.js.map
